module.exports = __webpack_public_path__ + "static/media/player-broken-shield.1a937d1e.png";